import { Component } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { CommonService, CrudComponent } from 'wire-frame';

import { TagModule } from 'primeng/tag';
import { ToggleButtonModule } from 'primeng/togglebutton';
import { DropdownModule } from 'primeng/dropdown';
import { ToolbarModule } from 'primeng/toolbar';
import { ToastModule } from 'primeng/toast';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { ConfirmationService } from 'primeng/api';
import { EditorModule } from 'primeng/editor';

import {PreConsultationService} from '../../../service/admin/pre-consultation.service';



import { ButtonModule } from 'primeng/button';
import { TabViewModule } from 'primeng/tabview';
import { identity } from 'rxjs';
import { ToasterService } from '../../../service/common/toaster.service';



@Component({  selector: 'app-Pre-Consultation',
  standalone: true,
  imports: [
        FormsModule,
    CommonModule,
    TagModule,
    ToggleButtonModule,
    DropdownModule,
    ToolbarModule,
    ToastModule,
    ConfirmDialogModule,
    CrudComponent,
    EditorModule,
    ButtonModule,
    TabViewModule],
  providers: [ConfirmationService, CommonService, PreConsultationService],
  templateUrl: './pre-consultation.component.html',
  styleUrl: './pre-consultation.component.scss'
})
export class PreConsultationComponent {
    activeIndex: number = 0;
  pationtIndex: number = 0;
  totalPrice: number = 0;
quantity: number = 0;
unitPrice: number = 0;
  
  
    public preconsultationList = [];
    public editRecord = null;
    public preconsultation = {
      id: '',                           // number
      bp: '',                         // string (Blood Pressure, e.g., "120/80")
pulseRate: 0,                    // number (Beats per minute)
temperature: 0,                  // number (in °C or °F)
weight: 0,                       // number (in kg)
height: 0,                       // number (in cm)
fastingBloodSugar: 0,            // number (mg/dL)
oxygenSaturation: 0,             // number (percentage, e.g., 98)
coldRunnyNose: false,             // boolean (true if present)
cough: false,                     // boolean (true if present)
currentComplaints: '',            // string (short description)
    };
  
    public closeFormEvent: boolean = false;
    public openDeletePopup: any = null;
    public activeMenu: string = 'personal';
  
    constructor(
      public common: CommonService,
      private toaster: ToasterService, private confirmationService: ConfirmationService,
      private PreConsultationService: PreConsultationService
    ) {
      this.common.breadCrum = {
        title: 'Visa Card Master',
        icon: 'user',
        list: ['Visa Card Master'],
      };
      this.common.setCrudTableHeaders([
       {
  title: 'Blood Pressure',
  val: 'bp',
  id: 'id',
  showColumn: true,
  filterColmn: true,
  order: 'asc',
  searchColumn: false,
  type: 'string',
  globalSearch: false,
},
{
  title: 'Pulse Rate',
  val: 'pulseRate',
  id: 'id',
  showColumn: true,
  filterColmn: true,
  order: 'asc',
  searchColumn: false,
  type: 'number',
  globalSearch: false,
},
{
  title: 'Temperature',
  val: 'temperature',
  id: 'id',
  showColumn: true,
  filterColmn: true,
  order: 'asc',
  searchColumn: false,
  type: 'number',
  globalSearch: false,
},
{
  title: 'Weight',
  val: 'weight',
  id: 'id',
  showColumn: true,
  filterColmn: true,
  order: 'asc',
  searchColumn: false,
  type: 'number',
  globalSearch: false,
},
{
  title: 'Height',
  val: 'height',
  id: 'id',
  showColumn: true,
  filterColmn: true,
  order: 'asc',
  searchColumn: false,
  type: 'number',
  globalSearch: false,
},
{
  title: 'Fasting Blood Sugar',
  val: 'fastingBloodSugar',
  id: 'id',
  showColumn: true,
  filterColmn: true,
  order: 'asc',
  searchColumn: false,
  type: 'number',
  globalSearch: false,
},
{
  title: 'Oxygen Saturation',
  val: 'oxygenSaturation',
  id: 'id',
  showColumn: true,
  filterColmn: true,
  order: 'asc',
  searchColumn: false,
  type: 'number',
  globalSearch: false,
},
{
  title: 'Cold / Runny Nose',
  val: 'coldRunnyNose',
  id: 'id',
  showColumn: true,
  filterColmn: true,
  order: 'asc',
  searchColumn: false,
  type: 'boolean',
  globalSearch: false,
},
{
  title: 'Cough',
  val: 'cough',
  id: 'id',
  showColumn: true,
  filterColmn: true,
  order: 'asc',
  searchColumn: false,
  type: 'boolean',
  globalSearch: false,
},
{
  title: 'Current Complaints',
  val: 'currentComplaints',
  id: 'id',
  showColumn: true,
  filterColmn: true,
  order: 'asc',
  searchColumn: true,
  type: 'string',
  globalSearch: true,
}]);
      this.common.setCrudActions([
        {
          title: '',
          icon: 'pi-pencil',
          classArr: 'me-2',
          tooltip: 'Update preconsultation',
        },
        { title: '', icon: 'pi-trash', tooltip: 'Delete preconsultation' }]);
    }
    
    ngOnInit() {
      this.getpreconsultation();
    }
  
     getpreconsultation() {
      this.PreConsultationService.getpreconsultation().subscribe((res: any) => {
        this.preconsultationList = res.data;
      })
    }
    
  
     closeForm() {
      this.clearForm();
      this.closeFormEvent = true;
      setTimeout(() => {
        this.closeFormEvent = false;
      }, 1);
    }
  
    
    clearForm() { 
      this.preconsultation = {
        id: '',                     // number (unique identifier)
      
        bp: '',                         // string (Blood Pressure, e.g., "120/80")
pulseRate: 0,                    // number (Beats per minute)
temperature: 0,                  // number (in °C or °F)
weight: 0,                       // number (in kg)
height: 0,                       // number (in cm)
fastingBloodSugar: 0,            // number (mg/dL)
oxygenSaturation: 0,             // number (percentage, e.g., 98)
coldRunnyNose: false,             // boolean (true if present)
cough: false,                     // boolean (true if present)
currentComplaints: '',            // string (short description)
      };
    }
     processpreconsultation() {
      if (this.preconsultation?.id) {
        this.updatepreconsultation();
      } else {
        this.addpreconsultation();
      }
    }
     addpreconsultation() {
      this.PreConsultationService.addpreconsultation(this.preconsultation).subscribe((res: any) => {
        if (res.status) {
          this.toaster.success(res.message);
          this.getpreconsultation();
          this.closeForm();
        } else {
          this.toaster.error(res.message);
        }
      });
    }
  
    updatepreconsultation() {
      this.PreConsultationService.updatepreconsultation(this.preconsultation).subscribe((res: any) => {
        if (res.status) {
          this.toaster.success(res.message);
          this.getpreconsultation();
          this.closeForm();
        } else {
          this.toaster.error(res.message);
        }
      });
    }
  
    
    deletepreconsultation(item: any) {
      this.PreConsultationService.deletepreconsultation(item).subscribe((res: any) => {
        this.toaster.success('preconsultation deleted successfully');
  
        this.getpreconsultation();
        this.closeForm();
      })
    }
  
    
    deleteRecord(event: any) {
      if(event) {
        this.deletepreconsultation(event);
      }
    }
  
    handleEvent(event: any) {
      // console.log(event);
      if(event.action.tooltip == "Update preconsultation") {
        this.editRecord = event.data;
        this.preconsultation = event.data;
        setTimeout(() => {
          this.editRecord = null;
        }, 1);
      } else if(event.action.tooltip == "Delete preconsultation") {
        this.editRecord = event.data;
        this.delRecPopupOpen({title: this.editRecord?.['name'], obj: this.editRecord});
      }
    }
  
    delRecPopupOpen(item: any) {
      this.openDeletePopup = item;
      setTimeout(() => {
        this.openDeletePopup = null;
      }, 1);
    }
    calculateTotalPrice(): void {
  const qty = Number(this.quantity) || 0;
  const price = Number(this.unitPrice) || 0;
  this.totalPrice = qty * price;
}
    
  

}
